import React from 'react';
import NotoLogoTagLineImg from '../Images/NotoLogo_no tagline.png';
const NotoLogoTagLine = (props) => {
    return (
        <img className="img-fluid" src={NotoLogoTagLineImg} alt="TrialStat" />
    );
};
export default NotoLogoTagLine;
